import { makeAutoObservable } from 'mobx'
import { ValidateCustomerController } from './validateCustomerController'
import { ErrorBag } from './errorBag'
import { RootStore } from './rootStore'
import Translator from '../components/translator'

export class StepController {
  /** @type StepController */
  static instance = null
  validationResults = new Map()
  static getInstance() {
    if (!this.instance) {
      this.instance = new StepController()
    }
    return this.instance
  }

  constructor() {
    makeAutoObservable(this)
  }

  validateCanGoToPaymentAddress() {
    const cart = RootStore.getInstance().cart
    this.validationResults.clear()
    if (cart.eventGroups.length <= 0) {
      this.validationResults.set('eventGroups',[
        ...this.validationResults.get('eventGroups') ?? [],
        Translator.translate('Please select at least one event group','type-validation')
      ])
    }
    cart.eventGroups.forEach(eventGroup => {
      if (eventGroup.participants.length <= 0) {
        this.validationResults.set('eventGroups.' + eventGroup.id,[
          ...this.validationResults.get('eventGroups.' + eventGroup.id) ?? [],
          Translator.translate('Du skal tilføje mindst én deltager!','type-validation')
        ])
      }
    })

    return this.canGoToPaymentAddress
  }

  get canGoToPaymentAddress() {
    const cart = RootStore.getInstance().cart
    return (
      cart.eventGroups.length > 0 &&
      !cart.eventGroups.some(eg => {
        return !(eg.participants.length > 0)
      })
    )
  }

  validateCanGoToPaymentMethod() {
    return ValidateCustomerController.getInstance().validate()
  }
  get canGoToPaymentMethod() {
    return ValidateCustomerController.getInstance().isValid()
  }

  validateCanGoToPayment() {
    const cart = RootStore.getInstance().cart

    if (!cart.customer.acceptance) {
      ErrorBag.getInstance().set('acceptance', { valid: false, error: Translator.translate('Du skal acceptere betingelserne','type-validation') })
    }

    if (!cart.customer.paymentMethod) {
      ErrorBag.getInstance().set('payment_method', { valid: false, error: Translator.translate('Du skal vælge en betalingsmetode','type-validation') })
    }
    ValidateCustomerController.getInstance().scrollErrorsIntoView()
    return this.canGoToPayment
  }
  get canGoToPayment(){
    const cart = RootStore.getInstance().cart

    return cart.customer.acceptance && cart.customer.paymentMethod
  }
}
